// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11dwD","index":"styles_index__1_u8O"};